export default __webpack_public_path__ + "static/MineralSwimV2_Brochure_ONLINEonly-bed83ac5742ea00106dc4799dca044bb.pdf";